import _groupBy from 'lodash/groupBy';
import _sumBy from 'lodash/sumBy';
import _get from 'lodash/get';
import I18n from 'i18n-js';
import {
  FIELD_PLACEHOLDER,
  POSTPAID_BILLING_TYPE,
} from 'constants/booking-constants';

export const sumByPaymentTypeID = payments => {
  /*
  * Groups by paymentTypeID and sums totals for each paymentTypeID
   */
  const groupByPaymentIDs = _groupBy(payments, 'paymentTypeID');
  const result = [];
  const paymentIDs = Object.keys(groupByPaymentIDs);
  paymentIDs.forEach(paymentID => {
    const paymentsGroup = groupByPaymentIDs[paymentID];
    const p = _get(paymentsGroup, '[0]', {});
    result.push({
      paymentType: p.type,
      refNumber: p.refNumber,
      total: _sumBy(paymentsGroup, 'amount'),
      description:
        p.type === POSTPAID_BILLING_TYPE
          ? I18n.t(FIELD_PLACEHOLDER.CORP_BILLING)
          : p.type,
      currency: p.currency,
    });
  });
  return result;
};

export const groupAndSumFailedPayments = failedPayments => {
  /* Group by currency, followed by paymentTypeID
  * Sum by total for each paymentTypeID
  * {
  *   IDR: [
  *    {
  *       paymentType: 'Mastercard',
  *       refNumber: 5379,
  *       total: 45000,
  *       description: 'MasterCard'/'Corporate Billing',
  *       currency: 'IDR',
  *    },
  *    {},
  * ],
  *   SGD: [],
  * }
  * */

  const groupByCurrencies = _groupBy(failedPayments, 'currency');
  const result = {};
  const currencies = Object.keys(groupByCurrencies);
  currencies.forEach(currency => {
    const paymentsGroup = groupByCurrencies[currency];
    result[currency] = sumByPaymentTypeID(paymentsGroup);
  });
  return result;
};

export default {};
